import { IApplicationState } from '../types/redux';

export const selectAgent = (state: IApplicationState) => state.realtorInfo.data?.agent;
